import type { NextPage } from 'next';
import { Content } from '@/components/dashboard/Content';

const Home: NextPage = () => {
  return <Content />;
};

export default Home;
